'use client'

import { type ReactNode, createContext, useCallback, useContext, useState } from 'react'

export type LogItem = {
  ts: number
  level: 'info' | 'warning' | 'error' | 'debug'
  type: string
  message: string
  details?: any
}

export type Log = {
  items: LogItem[],
  addItem: (item: LogItem) => void,
  hasItems: boolean,
  clearHasItems: () => void,
}

export const LogContext = createContext<Log>({
  items: [],
  hasItems: false,
  addItem: () => { },
  clearHasItems: () => { },
})

export interface LogProviderProps {
  children: ReactNode
}

export const LogProvider = ({
  children,
}: LogProviderProps) => {
  const [items, setItems] = useState<LogItem[]>([])
  const [hasItems, setHasItems] = useState<boolean>(false)

  const addItem = useCallback((item: LogItem) => {
    console.log('log item', item)
    setItems((prev) => [...prev, item].slice(-100))
    setHasItems(true)
  }, [])

  const clearHasItems = useCallback(() => {
    setHasItems(false)
  }, [])

  return (
    <LogContext.Provider value={{
      items,
      hasItems,
      addItem,
      clearHasItems,
    }}>
      {children}
    </LogContext.Provider>
  )
}

export const useLogProvider = () => {
  return useContext(LogContext)
}